import { styled } from 'config/stitches.config'

export const StyledJobs = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '$4'
})
